module.exports = __webpack_public_path__ + "img/Logos-EJ-continental.b5860173.jpg";